import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ThemeService } from '../../../services/theme.service';
import { interval, switchMap, takeWhile } from 'rxjs';
import { ReportGenerationJobsService } from '../../../services/reportGenerationJobs.service';

export interface DialogDataConfirmationDialogSignature {
  message: string;
  canOk: boolean;
  canCancel: boolean;
  messageOk: string;
  messageCancel: string;
  html: boolean;
  icon: boolean;
  dataIcon: string;
  idDocument: number;
}

@Component({
  selector: 'app-confirmation-dialog-report-job',
  templateUrl: './confirmation-dialog-report-job.component.html',
  styleUrl: './confirmation-dialog-report-job.component.scss',
  standalone: false
})
export class ConfirmationDialogReportJobComponent {
isProcessing: boolean;
 showSync: boolean;
 showCheck: boolean;
 fadeOut: boolean;

 constructor(
    private reportGenerationJobsService: ReportGenerationJobsService,
    private themeService: ThemeService,
    private translate: TranslateService,
    public dialogRef: MatDialogRef<ConfirmationDialogReportJobComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataConfirmationDialogSignature) { }

  ngOnInit(): void {
    this.isProcessing = true;
    this.showSync = true;
    this.showCheck = false;
    this.fadeOut = false;
    this.data.canOk = this.data.canOk != null ? this.data.canOk : true;
    this.data.canCancel = this.data.canCancel != null ? this.data.canCancel : true;
    this.data.message = this.translate.instant('notification.report.jobFinishedPending.message');

    interval(9000)
    .pipe(
      switchMap(() => this.reportGenerationJobsService.existsFinishedByIdDocument(this.data.idDocument)),
      takeWhile(
        result => result?.status !== 'NOTIFIED' || result?.status !== 'FAILED',
        true
      )
    )
    .subscribe({
      next: (result: any) => {
        if (result?.status === 'NOTIFIED') {
          this.data.message = this.translate.instant(
            'notification.report.jobFinished.message',
            { videoUrl: result.url }
          );

          this.data.canOk = true;
          this.isProcessing = false;
          this.fadeOut = true;

          setTimeout(() => {
            this.showSync = false;
            this.showCheck = true;
          }, 600);

        } else if (result?.status === 'FAILED') {

          this.data.message = this.translate.instant(
            'notification.report.jobFinishedError.message'
          );

          this.data.canOk = true;
          this.isProcessing = false;
          this.fadeOut = true;

          console.error(result.error);

          setTimeout(() => {
            this.showSync = false;
            this.showCheck = true;
          }, 600);
        }
      }
    });
      
  }

  onOkClick(): void {
    this.dialogRef.close(true);
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  getTheme(): string {
    return this.themeService.getTheme();
  }
}
